const $ = jQuery;
const Intro = {
	scrollDetect: () => {
		const scroll = $(window).scrollTop();
		const screenHeight = $(window).innerHeight();
		const header = $('.page-template-homepage-tpl #site-header');
		const body = $('body');
		const headerPostion = header.position();
		const animationClass = 'animate-header';
		const finishAnimationClass = 'animate-header-finished';
		if (header && header.length > 0) {
			const activationPostion = scroll + screenHeight / 2.5;
			if (headerPostion.top <= activationPostion) {
				body.addClass(animationClass);
				setTimeout(() => {
					if (body.hasClass(animationClass))
						body.addClass(finishAnimationClass);
				}, 800);
			} else {
				body.removeClass(finishAnimationClass);
				body.removeClass(animationClass);
			}
		}
	},
	init: () => {
		$(window).on('scroll', function (event) {
			Intro.scrollDetect();
		});
		$(document).on('load', function (event) {
			Intro.scrollDetect();
		});
	},
};
export default Intro;
